import React, { useMemo } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ConfigurationCommonModelsPageWrapper from "./ConfigurationCommonModelsPageWrapper";
import { getIntegrationCategoryList } from "../../../../models/Helpers";
import { commonModelsConfigurationPathForIndividualCategory } from "../../../../router/RouterUtils";
import { APICategory } from "../../../../models/Entities";
import ConfigurationCommonModelsPage from "./ConfigurationCommonModelsPage";
import { useDefaultScopesCategory } from "./common-model-scopes/hooks/useDefaultScopesCategory";
import ScopesTableSkeleton from "./common-model-scopes/components/ScopesTableSkeleton";
import ScopesToolbarSkeleton from "./common-model-scopes/components/ScopesToolbarSkeleton";
import useAppContext from "../../../context/useAppContext";

/**
 * Landing redirect for the scopes page when the URL has no category: resolves the category where the
 * org has enabled the most Common Models and redirects there, showing a spinner while the
 * per-category counts load. Kept as a component (rather than inline JSX in the Switch) so its
 * all-categories fetch only runs when this catch-all route actually mounts, not on category pages.
 */
const ScopesDefaultRedirect = ({ categories }: { categories: APICategory[] }) => {
  const category = useDefaultScopesCategory(categories);

  if (!category) {
    return (
      <div className="flex flex-col gap-y-3">
        <ScopesToolbarSkeleton />
        <ScopesTableSkeleton />
      </div>
    );
  }

  return <Redirect to={commonModelsConfigurationPathForIndividualCategory(category)} />;
};

function ConfigurationCommonModelsFullPage() {
  const { user } = useAppContext();
  const categories = useMemo(() => getIntegrationCategoryList(user), [user]);

  return (
    <ConfigurationCommonModelsPageWrapper>
      <Switch>
        {categories.map((category: APICategory) => (
          <Route
            key={category}
            exact
            path={commonModelsConfigurationPathForIndividualCategory(category)}
          >
            <ConfigurationCommonModelsPage category={category} />
          </Route>
        ))}
        <Route>
          <ScopesDefaultRedirect categories={categories} />
        </Route>
      </Switch>
    </ConfigurationCommonModelsPageWrapper>
  );
}

export default ConfigurationCommonModelsFullPage;
